/**
 * In-memory access-token store.
 *
 * Access tokens are short-lived (15 min) and live only in memory — never
 * persisted to localStorage, where they would be vulnerable to XSS exfil.
 * The refresh cookie (HttpOnly) is the durability mechanism: on tab reload,
 * we call /auth/refresh to get a new access token before rendering anything
 * that needs auth.
 */

let accessToken: string | null = null;
const listeners = new Set<(token: string | null) => void>();

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
  for (const listener of listeners) listener(accessToken);
}

export function subscribeToToken(listener: (token: string | null) => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
